import { gql } from '@apollo/client'

export const SOCIETE_UPDATE_MUTATION = gql`
  mutation SocieteUpdate($id: bigint!, $data: d4_societe_set_input!) {
    update_d4_societe_by_pk(pk_columns: { id: $id }, _set: $data) {
      id
      raisonsociale
      telportable
      telfixe
      mail1
      mail2
    }
  }
`
